export default {
  header: {
    signIn: 'Mag-sign In',
    signUp: 'Mag-sign Up'
  },
  userMenu: {
    wallet: 'Pitaka',
    withdraw: 'Mag-withdraw',
    transaction: 'Transaksyon',
    myBet: 'Aking Taya',
    rollover: 'Rollover',
    vault: 'Kabaong',
    profile: 'Profile',
    settings: 'Mga Setting',
    signOut: 'Mag-sign Out',
    signOutTitle: 'Mag-sign out',
    signOutContent: 'Tuklasin ang mundo na puno ng mga gantimpala at nakakaakit na laro!',
    signOutConfirm: 'Mag-sign out',
    cancel: 'Kanselahin'
  }
};
